import type { ClassArray } from "clsx";
import type { ClassValue } from "svelte/elements";

/** Provides autocompletion for tailwindcss */
export function tw(...classes: ClassArray): ClassValue {
	return classes;
}
